<template>
    <div>
        <div
            class="bigdata_container"
            id="bigdata"
            v-loading="isLoading"
            element-loading-text="拼命加载中..."
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <div
                id="container"
                class="mymap"
                style="width: 100%; heigh: clac(100vh-70px)"
            ></div>
            <!-- <div class="header"></div> -->
            <div class="customerTop">
                <img src="../assets/img/dateTop.png" alt="" srcset="" />
                <div class="titleFirst"></div>
                <div class="titleSecond"></div>
                <h1 v-if="this.$store.state.info.loginName == 'admin'">
                    凤阳县东陵村互助系统
                </h1>
                <h1 v-else>
                    {{ this.$store.state.info.orgName }}智慧养老可视化
                </h1>
            </div>
            <div class="quanp">
                <el-button
                    id="fullScreen"
                    @click="showFullScreen"
                    type="primary"
                    >{{ onFullScreen ? "退出全屏" : "进入全屏" }}</el-button
                >
            </div>

            <div style="position: relative">
                <div class="date-left">
                    <div class="date-date-top dataPresentation1">
                        <div class="date-list">
                            <div
                                v-for="(item, index) in titleList"
                                :key="index"
                                class="icon-title"
                            >
                                <div><img :src="item.imgPath" alt="" /></div>
                                <div :style="{ color: item.color }">
                                    {{ item.count }}
                                </div>
                                <div style="color: #ffffff">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 15px"></div>
                    <div class="date-date-top dataPresentation2">
                        <div class="date-title"></div>
                        <div
                            style="
                                width: 95%;
                                height: 150px;
                                margin-top: 20px;
                                overflow-y: auto;
                            "
                        >
                            <div
                                style="display: flex; margin: 10px 0"
                                v-for="(item, index) in this.conuts"
                                :key="index"
                            >
                                <span
                                    style="
                                        width: 20%;
                                        color: #ffffff;
                                        margin-left: 20px;
                                        font-size: 12px;
                                    "
                                    >{{ item.dictName }}</span
                                ><el-progress
                                    style="width: 52%"
                                    :text-inside="true"
                                    :stroke-width="16"
                                    :percentage="setItemProgress(item)"
                                    :format="setItemText(item)"
                                ></el-progress
                                ><span
                                    style="
                                        width: 15%;
                                        color: #ffffff;
                                        margin-left: 20px;
                                    "
                                    >{{ item.count }}</span
                                >
                            </div>
                            <!-- <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >应急救援</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="1"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >1</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >城市运行</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="2"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >2</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >文化教育</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="6"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >6</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >关爱教育</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="0"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >0</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >社区服务</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="0"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >0</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >医疗卫生</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="0"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >0</span
                >
              </div>
              <div style="display: flex; margin: 10px 0">
                <span style="width: 20%; color: #ffffff; margin-left: 20px"
                  >其他</span
                ><el-progress
                  style="width: 50%"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="0"
                ></el-progress
                ><span style="width: 15%; color: #ffffff; margin-left: 20px"
                  >0</span
                >
              </div> -->
                        </div>
                    </div>
                    <div style="height: 15px"></div>
                    <div class="date-date-top dataPresentation3">
                        <div class="date-title"></div>
                        <div class="date-list">
                            <Statistics></Statistics>
                        </div>
                    </div>
                </div>
                <div class="date-center1 dataPresentation4">
                    <div class="date-date-top">
                        <div class="date-goog"></div>
                        <div class="date-list" style="margin-top: 10px">
                            <GoodPerson></GoodPerson>
                        </div>
                    </div>
                </div>
                <div class="date-center2 dataPresentation5">
                    <div class="date-date-top">
                        <!-- <div class="date-title">
                        </div> -->
                        <div class="date-list" style="margin-top: 10px">
                            <ZheyuanzheLine></ZheyuanzheLine>
                        </div>
                    </div>
                </div>
                <div class="date-right">
                    <div class="date-date-top dataPresentation6">
                        <div class="date-title">
                            <!-- <div>团队组织活动排名</div> -->
                        </div>
                        <div class="date-list">
                            <DateLine></DateLine>
                        </div>
                    </div>
                    <div
                        class="date-date-top dataPresentation7"
                        style="margin: 10px 0"
                    >
                        <div class="date-title">
                            <!-- <div>服务对象统计</div> -->
                        </div>
                        <div class="weekBox">
                            <div class="weekTop">
                                <P class="weekItem">序号</P>
                                <P class="weekItem">团队名称</P>
                                <P class="weekItem">联系人</P>
                                <P class="weekItem">人数</P>
                                <P class="weekItem">地址</P>
                            </div>
                            <div
                                style="height: 150px; overflow-y: auto"
                                v-if="
                                    this.$store.state.info.loginName == 'admin'
                                "
                            >
                                <div class="weekTops">
                                    <P class="weekItem">1</P>
                                    <P class="weekItem">党员志愿队</P>
                                    <P class="weekItem">曹德寿</P>
                                    <P class="weekItem">5</P>
                                    <P class="weekItem">东陵村</P>
                                </div>
                                <div class="weekTops">
                                    <P class="weekItem">2</P>
                                    <P class="weekItem">东林邻里互助队</P>
                                    <P class="weekItem">吴天玉</P>
                                    <P class="weekItem">6</P>
                                    <P class="weekItem">东陵村东林队</P>
                                </div>
                                <div class="weekTops">
                                    <P class="weekItem">3</P>
                                    <P class="weekItem">西林邻里互助队</P>
                                    <P class="weekItem">徐兰雯</P>
                                    <P class="weekItem">5</P>
                                    <P class="weekItem">东陵村西林队</P>
                                </div>
                                <div class="weekTops">
                                    <P class="weekItem">4</P>
                                    <P class="weekItem">邻里结对</P>
                                    <P class="weekItem">17队</P>
                                    <P class="weekItem">34</P>
                                    <P class="weekItem">东陵村</P>
                                </div>
                                <div class="weekTops">
                                    <P class="weekItem">5</P>
                                    <P class="weekItem">义剪服务队</P>
                                    <P class="weekItem">车秀英</P>
                                    <P class="weekItem">3</P>
                                    <P class="weekItem">东陵村</P>
                                </div>
                                <div class="weekTops">
                                    <P class="weekItem">6</P>
                                    <P class="weekItem">娱乐互助队</P>
                                    <P class="weekItem">尤振贵</P>
                                    <P class="weekItem">8</P>
                                    <P class="weekItem">东陵村</P>
                                </div>
                            </div>
                            <div style="height: 150px; overflow-y: auto" v-else>
                                <div
                                    class="weekTops"
                                    v-for="(item, index) in findLists"
                                    :key="index"
                                >
                                    <P class="weekItem">{{
                                        Number(index) + 1
                                    }}</P>
                                    <P class="weekItem">{{ item.name }}</P>
                                    <P class="weekItem">{{ item.contacts }}</P>
                                    <P class="weekItem">{{
                                        item.formalMembers
                                    }}</P>
                                    <P class="weekItem">{{ item.address }}</P>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="date-date-top dataPresentation8">
                        <div class="date-title">
                            <!-- <div>兑换商品排名</div> -->
                        </div>
                        <div class="date-list">
                            <Commodity></Commodity>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BusinessDialog
            ref="business"
            v-if="showShangjia"
            :shangjiaId="shangjiaId"
            @setBuiness="setBuiness"
        ></BusinessDialog>
        <TeamDialog
            ref="teamDialog"
            v-if="showTeam"
            :teamId="teamId"
            @setTeam="setTeam"
        ></TeamDialog>
        <ZhyzhDialog
            ref="zhiyuanzhe"
            v-if="showZhiyuanzhe"
            :zhiyuanzheId="zhiyuanzheId"
            @setShow="setShow"
        ></ZhyzhDialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import DateLine from "./components/line.vue"
import ZheyuanzheLine from "./components/zheyuanzheLine.vue"
import SexStatistics from "./components/sexStatistics.vue"
import ChinaMap from "./components/chinaMap.vue"
import GoodPerson from "./components/goodPerson.vue"
import Team from "./components/team.vue"
import Statistics from "./components/statistics.vue"
import Commodity from "./components/commodity.vue"
import BusinessDialog from "./components/businessDialog.vue"
import TeamDialog from "./components/teamDialog.vue"
import ZhyzhDialog from "./components/zhyzhDialog.vue"
export default {
    components: {
        DateLine,
        SexStatistics,
        ChinaMap,
        ZheyuanzheLine,
        GoodPerson,
        Team,
        Statistics,
        Commodity,
        BusinessDialog,
        TeamDialog,
        ZhyzhDialog,
    },
    data() {
        return {
            findLists: [
                // {
                //   name: "打扫院内卫生",
                //   contacts: "李悦欣",
                //   formalMembers: "5",
                //   address: "安徽省池州市凤阳县云霁",
                // },
                // {
                //   name: "象棋比赛",
                //   contacts: "金鑫",
                //   formalMembers: "5",
                //   address: "安徽省池州市凤阳县云霁",
                // },
                // {
                //   name: "打太极",
                //   contacts: "陈龙斌",
                //   formalMembers: "5",
                //   address: "安徽省池州市凤阳县云霁",
                // },
                // {
                //   name: "散步",
                //   contacts: "陈龙斌",
                //   formalMembers: "5",
                //   address: "安徽省池州市凤阳县云霁",
                // },
            ],
            normalInfo: {},
            isLoading: true,
            onFullScreen: false,
            titleList: [],
            teamId: {},
            zhiyuanzheId: {},
            shangjiaId: {},
            showTeam: false,
            showZhiyuanzhe: false,
            showShangjia: false,
            keyword: "",
            map: null,
            markers: [],
            unitList: [],
            volunteerList: [],
            corporationList: [],
            conuts: [],
            totalCount: "",
            conuts0: "",
            conuts1: "",
            conuts2: "",
            conuts3: "",
            conuts4: "",
            conuts5: "",
            conuts6: "",
            conuts7: "",
        }
    },
    created() {
        this.$store.commit("isFull", false)
        this.getOrg()
        this.gethuodong()
    },
    mounted() {
        this.getDataList() //数据展示
        this.showLists()
        const self = this
        document.addEventListener(
            "fullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "msfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "mozfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )

        document.addEventListener(
            "webkitfullscreenchange",
            function () {
                self.onFullScreen =
                    document.fullscreenElement == null ? false : true
            },
            false
        )
    },
    _methods: {
        setItemText(data) {
            return () => {
                return (
                    parseInt((data.count / this.totalCount).toFixed(2) * 100) +
                    "%"
                )
            }
        },
        setItemProgress(data) {
            if (data.count && this.totalCount) {
                return parseInt((data.count / this.totalCount).toFixed(2) * 100)
            }
        },
        showLists() {
            this.$http
                .request({
                    url: "/sqyl/admin/corporationRecruitment/info/list",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: -1,
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.findLists = res.content.list
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        setShow() {
            this.showZhiyuanzhe = false
        },
        setBuiness() {
            this.showShangjia = false
        },
        setTeam() {
            this.showTeam = false
        },
        gethuodong() {
            // this.$post('/sqy/admin/activityRecruitment/info/activityTypeCount',{}).then(res => {
            //   console.log(res);
            // })
            this.$http
                .request({
                    url: "/sqyl/admin/activityRecruitment/info/activityTypeCount",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    this.conuts = res.content
                    this.totalCount =
                        this.conuts[0].count +
                        this.conuts[1].count +
                        this.conuts[2].count +
                        this.conuts[3].count +
                        this.conuts[4].count +
                        this.conuts[5].count +
                        this.conuts[6].count +
                        this.conuts[7].count
                })
        },

        loadMap() {
            let self = this
            //地图加载
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container", {
                    resizeEnable: true,
                    mapStyle: "amap://styles/darkblue",
                    zoom: 9,
                    // postion: [111.546275, 33.837575],
                })
                if (
                    this.$store.state.orgAreaLevel == 1 ||
                    this.$store.state.orgAreaLevel == 2 ||
                    this.$store.state.orgAreaLevel == 3
                ) {
                    let cities = [this.$store.state.orgAreaName]
                    for (let i = 0; i < cities.length; i++) {
                        this.areaBG(this.map, cities[i])
                        this.map.setZoom(8)
                    }
                } else if (
                    this.$store.state.orgAreaLevel == 4 ||
                    this.$store.state.orgAreaLevel == 5
                ) {
                    console.log("社区，街道", this.$store.state.orgId)

                    if (this.$store.state.orgId != 0) {
                        this.$http
                            .request({
                                url: "/rbac/admin/org/info/findOrgById",
                                method: "POST",
                                data: {
                                    id: this.$store.state.orgId,
                                },
                            })
                            .then((res) => {
                                var polygonArr = []
                                res.content.pointPosition
                                    .split(",")
                                    .forEach((i) => {
                                        console.log(i)
                                        polygonArr.push(i.split(":"))
                                    })
                                this.polygon = new AMap.Polygon({
                                    map: this.map,
                                    strokeWeight: 1,
                                    path: polygonArr,
                                    fillOpacity: 0.3,
                                    fillColor: "#2191E6",
                                    strokeColor: "#007CDB",
                                })
                                let maxlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlng =
                                        maxlng < polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : maxlng
                                }
                                let minlng = polygonArr[0].lng
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlng =
                                        minlng > polygonArr[i + 1].lng
                                            ? polygonArr[i + 1].lng
                                            : minlng
                                }
                                let lngs =
                                    parseInt(minlng) +
                                    (parseInt(maxlng) - parseInt(minlng)) / 2
                                let maxlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    maxlat =
                                        maxlat < polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : maxlat
                                }
                                let minlat = polygonArr[0].lat
                                for (
                                    let i = 0;
                                    i < polygonArr.length - 1;
                                    i++
                                ) {
                                    minlat =
                                        minlat > polygonArr[i + 1].lat
                                            ? polygonArr[i + 1].lat
                                            : minlat
                                }
                                let lats =
                                    parseInt(minlat) +
                                    (parseInt(maxlat) - parseInt(minlat)) / 2
                                this.map.setZoomAndCenter(7, [lngs, lats])
                                // this.map.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                                this.polygon.setMap(self.map)
                            })
                    }
                } else {
                    this.map.setZoom(8)
                }
                resolve()
            })
        },
        areaBG(map, cityName) {
            console.log(cityName, "cityName")
            AMap.service("AMap.DistrictSearch", function () {
                let opts = {
                    subdistrict: 0,
                    extensions: "all",
                    level: "district", // 查询行政级别为市
                }
                // 实例化DistrictSearch
                let district = new AMap.DistrictSearch(opts)
                district.setLevel("district")
                // 行政区查询
                district.search(`${cityName}`, function (status, result) {
                    // 获取边界信息
                    let bounds = result.districtList[0].boundaries
                    let polygons = []
                    if (bounds) {
                        for (let i = 0, l = bounds.length; i < l; i++) {
                            // 生成行政区划polygon
                            let polygon = new AMap.Polygon({
                                map: map,
                                strokeWeight: 1,
                                path: bounds[i],
                                fillOpacity: 0.3,
                                fillColor: "#2191E6",
                                strokeColor: "#007CDB",
                            })
                            polygons.push(polygon)
                            console.log(polygon)
                        }
                    }
                })
            })
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                        await this.loadMap()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },
        FullCreeen(element) {
            let el = document.getElementById("bigdata")
            let rfs =
                el.requestFullScreen ||
                el.webkitRequestFullScreen ||
                el.mozRequestFullScreen ||
                el.msRequestFullScreen

            if (typeof rfs != "undefined" && rfs) {
                rfs.call(el)
                this.$store.commit("isFull", true)
            } else if (typeof window.ActiveXObject != "undefined") {
                // this.$store.commit("isFull", false)
                let wscript = new ActiveXObject("WScript.Shell")
                if (wscript != null) {
                    wscript.SendKeys("{F11}")
                }
            }
        },
        getDataList() {
            request({
                url: "/sqyl/admin/corporationRecruitment/info/corporationCount",
                method: "POST",
                data: {},
            }).then((res) => {
                if (res.code == 200) {
                    this.titleList = res.content
                    this.titleList.forEach((item, index) => {
                        if (item.name == "团队信息") {
                            item.imgPath = require("../assets/img/tuandui.png")
                            item.color = "#1f99ca"
                        } else if (item.name == "志愿者") {
                            item.imgPath = require("../assets/img/zhiyuanzhe.png")
                            item.color = "#10df24"
                        } else {
                            item.imgPath = require("../assets/img/shangjia.png")
                            item.color = "#e39a0f"
                        }
                    })
                    this.isLoading = false
                    // 志愿者
                    this.getVolunteerArchive()
                    // 团队
                    this.getCorporationRecruitment()
                    // 商家
                    this.getUnitInformation()
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        // 志愿者
        getVolunteerArchive() {
            const self = this
            self.$http
                .request({
                    url: "/sqyl/admin/volunteerArchive/info/list",
                    method: "POST",
                    data: {
                        auditResult: "1",
                        pageNo: 1,
                        pageSize: 1000,
                        userName: "",
                        volunteerArchiveCode: "",
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            if (res.content.list) {
                                self.volunteerList = []
                                // this.volunteerList = res.content.list
                                res.content.list.forEach((item, index) => {
                                    item.tubiao = require("../assets/img/zhyzh-icon.png") //绿色
                                    item.typeId = "zhiyuanzhe"
                                    item.latitude = Number(item.latitude)
                                    item.longitude = Number(item.longitude)
                                    if (item.latitude && item.longitude) {
                                        self.volunteerList.push(item)
                                    }
                                })
                                await self.renderMapMarker(res.content.list)
                            } else {
                                self.volunteerList = []
                            }
                        } else {
                            self.volunteerList = []
                        }
                    } else {
                        self.$message.error(res.message)
                    }
                })
        },
        // 团队
        getCorporationRecruitment() {
            const self = this
            self.$http
                .request({
                    url: "/sqyl/admin/corporationRecruitment/info/list",
                    method: "POST",
                    data: {
                        approvalStatus: "1",
                        name: "",
                        pageNo: 1,
                        pageSize: 1000,
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            if (res.content.list) {
                                self.corporationList = []
                                // this.corporationList = res.content.list
                                res.content.list.forEach((item, index) => {
                                    item.tubiao = require("../assets/img/td-icon.png") //蓝色
                                    item.typeId = "tuandui"
                                    item.latitude = Number(item.latitude)
                                    item.longitude = Number(item.longitude)
                                    if (item.latitude && item.longitude) {
                                        // res.content.list.splice(index, 1)
                                        self.corporationList.push(item)
                                    }
                                })
                                await self.renderMapMarker(res.content.list)
                            } else {
                                self.corporationList = []
                            }
                        } else {
                            self.corporationList = []
                        }
                    } else {
                        self.$message.error(res.message)
                    }
                })
        },
        // 商家
        getUnitInformation() {
            const self = this
            self.$http
                .request({
                    url: "/sqyl/admin/unitInformation/info/list",
                    method: "POST",
                    data: {
                        approvalStatus: "1",
                        pageNo: 1,
                        pageSize: 1000,
                        unitName: "",
                    },
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content) {
                            if (res.content.list) {
                                self.unitList = []
                                // this.unitList = res.content.list
                                res.content.list.forEach((item, index) => {
                                    item.tubiao = require("../assets/img/shj-icon.png") //黄色
                                    item.typeId = "shangjia"
                                    item.latitude = item.latitude
                                    item.longitude = item.longitude
                                    // if (item.latitude && item.longitude) {
                                    //     res.content.list.splice(index, 1)
                                    //     self.unitList.push(item)
                                    // }
                                })
                                await self.renderMapMarker(res.content.list)
                            } else {
                                self.unitList = []
                            }
                        } else {
                            self.unitList = []
                        }
                    } else {
                        self.$message.error(res.message)
                    }
                })
        },
        renderMapMarker(data) {
            console.log(data, "数量")
            let self = this
            let marker = null
            // this.map.clearMap()
            data.forEach((item) => {
                marker = new AMap.Marker({
                    position: [item.longitude, item.latitude],
                    icon: new AMap.Icon({
                        image: item.tubiao,
                        size: new AMap.Size(52, 52),
                        imageSize: new AMap.Size(30, 30),
                    }),
                    // title: item.detailAddress,
                    offset: new AMap.Pixel(-13, -30), //往左往上
                })
                self.markers.push(marker)

                marker.on("mouseover", (e) => {
                    marker.setTitle(item.name)
                })
                marker.on("click", (e) => {
                    // console.log(item, "我选中的数据")
                    if (item.typeId == "shangjia") {
                        self.shangjiaId = { id: item.id, state: true }
                        self.showShangjia = true
                    }
                    if (item.typeId == "tuandui") {
                        self.teamId = { id: item.id, state: true }
                        self.showTeam = true
                    }
                    if (item.typeId == "zhiyuanzhe") {
                        self.zhiyuanzheId = { id: item.id, state: true }
                        self.showZhiyuanzhe = true
                    }
                })
            })
            self.map.add(self.markers)
            self.map.add(self.polygon)
            // self.map.setZoom(7)
            console.log(self.markers, "打点数量")
        },
    },
    get methods() {
        return this._methods
    },
    set methods(value) {
        this._methods = value
    },
}
</script>

<style lang="less" scoped>
#container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
    z-index: 1;
}
.customerTop {
    img {
        width: 100%;
        height: 88px;
    }
    h1 {
        color: #c7ebff;
        position: absolute;
        text-align: center;
        font-weight: bolder;
        font-size: 33px;
        left: 0;
        top: 1px;
        width: 100%;
        height: 78px;
        line-height: 78px;
        z-index: 3;
    }
    .titleFirst {
        min-width: 560px;
        position: absolute;
        width: 560px;
        // border-top: 78px solid #1e69b6;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -310px;
        z-index: 2;
    }
    .titleSecond {
        min-width: 620px;
        width: 620px;
        position: absolute;
        // border-top: 78px solid #103b71;
        border-left: 40px solid transparent;
        border-right: 40px solid transparent;
        height: 0;
        left: 50%;
        top: 0;
        margin-left: -340px;
    }
}
.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
	.nameoftransition-leave-to

	/* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

//引入的字体样式
@font-face {
    font-family: "Unidtrsmled";
    src: url(../assets/font/UnidreamLED.ttf);
}

.quanp {
    width: 200px;
    height: 100px;
    float: right;
    position: absolute;
    top: 20px;
    right: -110px;

    button {
        padding: 10px;
    }
}

.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .el-carousel__container {
    height: 100% !important;

    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../assets/img/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .header {
        margin: auto;
        width: 90%;
        height: 100px;
        background: url("../assets/img/dateTop.png") no-repeat center center;
        background-size: 100%;
    }
}

.date-left {
    width: 22%;
    margin-left: 1%;
    // margin-top: 1%;
    padding: 1% 1% 0.3% 1%;
    // border: 1px solid #2e48a0;
    z-index: 90;
    position: relative;
}

.date-title {
    width: 100%;
    display: flex;
}

.date-title > div:first-child {
    line-height: 30px;
    border-left: 4px solid #29dce3;
    font-size: 15px;
    color: #29dce3;
    padding-left: 15px;
    width: 95%;
    margin: 0 auto;
    background-image: linear-gradient(
        to right,
        rgba(69, 214, 216, 0.3),
        rgba(0, 0, 0, 0)
    );
}

.date-list {
    width: 100%;
    display: flex;
    align-items: center;
}

.icon-title {
    width: 33%;
    text-align: center;
}

.icon-title > div:first-child {
    margin: 20px 0 0 0;
}

.icon-title > div:nth-child(2) {
    margin: 10px 0 0 0;
}

.icon-title > div:nth-child(3) {
    margin: 10px 0 0 0;
}

.main_center {
    position: absolute;
    top: 10%;
    left: 1%;
    overflow-y: auto;
    z-index: 100000;
}

.date-center1 {
    width: 22%;
    margin-left: 1%;
    padding: 1% 1%;
    background: url(../assets/img/a3.png);
    background-size: 100% 100%;
    z-index: 90;
    position: absolute;
    left: 24.5%;
    bottom: 0.1%;
}

.date-center2 {
    width: 22%;
    margin-left: 1%;
    padding: 1% 1%;
    background: url(../assets/img/a3.png);
    background-size: 100% 100%;
    z-index: 90;
    position: absolute;
    left: 49%;
    bottom: 0.1%;
}

.date-goog {
    width: 95%;
    display: flex;
    line-height: 30px;
    border-left: 4px solid #29dce3;
    font-size: 15px;
    color: #29dce3;
    padding-left: 15px;
    justify-content: space-between;
    margin: 0 auto;
    background-image: linear-gradient(
        to right,
        rgba(69, 214, 216, 0.3),
        rgba(0, 0, 0, 0)
    );
}

.date-right {
    width: 22%;
    margin-left: 1%;
    margin-top: 1%;
    padding: 1% 1% 0.9% 1%;
    // border: 1px solid #2e48a0;
    z-index: 90;
    position: absolute;
    right: 1.5%;
    top: -2%;
    bottom: 0.1%;
}

.top-left {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0px;
    left: 0;
    // background: url(../assets/img/zuo1_img.png) no-repeat center;
    // background-size: 100% 100%;
}

.top-right {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 0;
    // background: url(../assets/img/you1_img.png) no-repeat center;
    // background-size: 100% 100%;
}

.bottom-left {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    left: 0;
    // background: url(../assets/img/zuo2_img.png) no-repeat center;
    // background-size: 100% 100%;
}

.bottom-right {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
    // background: url(../assets/img/you2_img.png) no-repeat center;
    // background-size: 100% 100%;
}
.dataPresentation1 {
    padding-top: 35px;
    padding-bottom: 20px;
    background: url(../assets/img/presentation1.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation2 {
    padding-top: 35px;
    padding-bottom: 20px;
    background: url(../assets/img/presentation2.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation3 {
    padding-top: 35px;
    padding-bottom: 20px;
    background: url(../assets/img/presentation3.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation4 {
    padding-top: 35px;
    padding-bottom: 20px;
    background: url(../assets/img/presentation4.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation5 {
    padding-top: 35px;
    padding-bottom: 20px;
    background: url(../assets/img/presentation5.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation6 {
    padding-top: 20px;
    // padding-bottom: 10px;
    background: url(../assets/img/presentation6.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation7 {
    padding-top: 20px;
    padding-bottom: 15px;
    background: url(../assets/img/presentation7.png) no-repeat center;
    background-size: 100% 100%;
}
.dataPresentation8 {
    padding-top: 20px;
    padding-bottom: 15px;
    background: url(../assets/img/presentation8.png) no-repeat center;
    background-size: 100% 100%;
}
.weekBox {
    width: 90%;
    .weekTop {
        margin-top: 20px;
        margin-left: 10px;
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        border-bottom: 1px solid #fff;
        line-height: 40px;
        justify-content: center;
    }
    .weekTops {
        display: flex;
        align-items: cneter;
        font-size: 13px;
        text-align: center;
        color: #fff;
        line-height: 25px;
        justify-content: center;
    }
    .weekEats {
        height: 72px;
        .weekEat {
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 24px;
            color: #fff;
            height: 24px;
            font-size: 12px;
        }
    }
    .typeName {
        width: 60px;
        position: relative;
        text-align: center;
        font-size: 12px !important;
        color: #fff !important;
    }
    .weekItem {
        flex: 1;
        font-size: 12px !important;
        color: #fff !important;
        width: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
/deep/ .el-progress-bar__innerText {
    margin-bottom: 4px;
}
</style>
